module.exports = __webpack_public_path__ + "assets/img/3.28c05822.png";